/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".instruction-menu[_ngcontent-%COMP%]{width:180px}a.disabled[_ngcontent-%COMP%]{pointer-events:none;cursor:default;color:#d3d3d3}"];
export { styles as styles };
